export default __webpack_public_path__ + "static/media/bet.dd335236.svg";